/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import * as constants from "../../constants/teaserList";

function list(state = { key: "add_date", order: "desc" }, action) {
  if (action.type == constants.SET_TEASER_LIST_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

function stat(state = { key: "date", order: "desc" }, action) {
  if (action.type == constants.SET_TEASER_STAT_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

export default combineReducers({
  list,
  stat
});
